import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { sortByProperty } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'keys-list',
    components: {

    },
})

export default class KeysList extends Vue {

    private tableFields: any = [
        {
            label: 'S. no',
            key: 'index',
            thClass: 'index-sl',
        },
        {
            label: 'Setting Key',
            key: 'settingKey',
            thClass: 'settingKey',
        },
        {
            label: 'Description',
            key: 'description',
            thClass: 'description',
        },
        {
            label: 'UI element Type',
            key: 'uiElementType',
            thClass: 'uiElementType',
        },
        {
            label: 'Action',
            key: 'action',
            thClass: 'action',
        },

    ];

    private uiElementTypes: any = {
        'input-text': 'Input text',
        'input-json': 'Input json',
        'toggle-boolean': 'Toggle boolean',
        'toggle-string': 'Toggle string',
        'taxonomy-picker': 'Taxonomy picker',
    };

    private settingKeys: any = [];

    private async created() {
        this.settingKeys = await this.fetchSettingsList();
    }

    private async fetchSettingsList() {
        return await tenantSettingsAPI.fetcTenantConfigKeysRawList();
    }

    private onSwitchComponent(key: any) {
        const isEditMode = false;
        this.$emit('onSwitchComponent', key, null , isEditMode);
    }

    private onEdit(data: any) {
        const isEditMode = true;
        this.$emit('onSwitchComponent', 'add-keys', data, isEditMode);
    }

    private async onDelete(data: any) {
        const dataKey = data.settingKey;
        await adminUtilsAPI.deleteSettingKey(dataKey);
        this.settingKeys = await this.fetchSettingsList();
    }
}
